import React from 'react';
import { Button, Typography } from 'react-covideo-common';
import { NewModal } from 'lib/components';
import { Flex } from 'lib/components/styles/layout';
import { Formik, Form } from 'formik';
import { FormikRadioField } from 'lib/components/formik/FormikRadioField';
import { useTranslation } from 'react-i18next';

export type ChangeWeeklyReportModalData = {
  userIds: number[];
  weeklyReportEnabled: boolean;
};

type FormValues = {
  weeklyReportEnabled: number;
};

type Props = {
  handleModalClose: (shouldRefresh?: boolean | number) => void;
  selectedUserIds?: number[];
  onApply: (userIds: number[], weeklyReportEnabled: boolean) => Promise<void>;
  isLoading: boolean;
};

const initialValues: FormValues = {
  weeklyReportEnabled: 1,
};

export const ChangeWeeklyReportModal = ({
  handleModalClose,
  selectedUserIds,
  onApply,
  isLoading,
}: Props) => {
  const { t } = useTranslation();

  const count = selectedUserIds?.length ?? 0;

  const headerText =
    count === 1
      ? t('Report Settings for 1 user')
      : t('Report Settings for {{count}} users', { count });

  const handleSubmit = async (values: FormValues) => {
    await onApply(selectedUserIds ?? [], values.weeklyReportEnabled === 1);
  };

  return (
    <NewModal
      headerText={headerText}
      hideHeader={false}
      closeModalOnBackdropOrEscPress={true}
      closeModal={() => handleModalClose()}
      headerMargin='0 0 24px 0'
      style={{
        content: {
          padding: '24px 24px 16px 24px',
          paddingLeft: '32px',
        },
      }}
    >
      <Formik<FormValues> initialValues={initialValues} onSubmit={handleSubmit}>
        <Form>
          <Flex flexDirection='column' gap='16px'>
            <Typography variant='normal'>
              {t('Set weekly report for the selected users.')}
            </Typography>

            <Flex flexDirection='column' gap='8px'>
              <FormikRadioField
                name='weeklyReportEnabled'
                label={t('Enable')}
                value={1}
              />
              <FormikRadioField
                name='weeklyReportEnabled'
                label={t('Disable')}
                value={0}
              />
            </Flex>

            <Button
              text={t('Apply')}
              style={{ width: 'fit-content', alignSelf: 'flex-end' }}
              type='submit'
              disabled={isLoading}
            />
          </Flex>
        </Form>
      </Formik>
    </NewModal>
  );
};
